import {useMessagePartText} from '@assistant-ui/react';
import Markdown from '@wandb/weave/common/components/Markdown';
import {MarkdownContainer} from '@wandb/weave/components/PagePanelComponents/Home/Browse3/pages/ChatView/MarkdownContainer';
import React, {memo} from 'react';

export const WBAgentMarkdown = memo(({content}: {content: string}) => (
  <MarkdownContainer>
    <Markdown content={content} shouldEjectFromTailwind={false} />
  </MarkdownContainer>
));
WBAgentMarkdown.displayName = 'WBAgentMarkdown';

const MarkdownTextImpl = () => {
  const {text} = useMessagePartText();
  return <WBAgentMarkdown content={text} />;
};

export const MarkdownText = memo(MarkdownTextImpl);
